import { render, staticRenderFns } from "./setLoginPwd.vue?vue&type=template&id=4784372c&scoped=true&"
import script from "./setLoginPwd.vue?vue&type=script&lang=js&"
export * from "./setLoginPwd.vue?vue&type=script&lang=js&"
import style0 from "./setLoginPwd.vue?vue&type=style&index=0&id=4784372c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4784372c",
  null
  
)

export default component.exports